import { axiosInstance } from "./ServiceConstants";
import axios, { CancelToken } from "axios";
import { INotification, ICreateNotification } from "../models/INotification";

class NotificationService {
    async getEventNotifications(raceId: string, cancelToken?: CancelToken): Promise<INotification[]> {
        try {
            const result = await axiosInstance.get<INotification[]>(
                `api/Notifications/event/${raceId}`,
                { cancelToken }
            );
            return result.data;
        } catch (e) {
            if (axios.isCancel(e)) throw e;
            console.error(e);
            return [];
        }
    }

    async createEventNotification(raceId: string, notification: ICreateNotification): Promise<INotification> {
        const result = await axiosInstance.post<INotification>(
            `api/Notifications/event/${raceId}`,
            notification
        );
        return result.data;
    }

    async updateEventNotification(raceId: string, notificationId: string, notification: ICreateNotification): Promise<INotification> {
        const result = await axiosInstance.put<INotification>(
            `api/Notifications/event/${raceId}/${notificationId}`,
            notification
        );
        return result.data;
    }

    async finishEventNotification(raceId: string, notificationId: string, notification: INotification): Promise<INotification> {
        const result = await axiosInstance.put<INotification>(
            `api/Notifications/event/${raceId}/${notificationId}`,
            {
                severity: notification.severity,
                subject: notification.subject,
                description: notification.description,
                notificationStart: notification.notificationStart,
                notificationEnd: new Date(),
            }
        );
        return result.data;
    }

    async getRiderNotifications(raceId: string, riderId: string, cancelToken?: CancelToken): Promise<INotification[]> {
        try {
            const result = await axiosInstance.get<INotification[]>(
                `api/Notifications/event/${raceId}/rider/${riderId}`,
                { cancelToken }
            );
            return result.data;
        } catch (e) {
            if (axios.isCancel(e)) throw e;
            console.error(e);
            return [];
        }
    }

    async createRiderNotification(raceId: string, riderId: string, notification: ICreateNotification): Promise<INotification> {
        const result = await axiosInstance.post<INotification>(
            `api/Notifications/event/${raceId}/rider/${riderId}`,
            notification
        );
        return result.data;
    }
}

const NotificationServiceInstance = new NotificationService();

export default NotificationServiceInstance;
